import $ from 'jquery';

const bob = {
    scrollTreshold: 1,
    init() {
        $.noConflict();

        // $('img.lazy').Lazy();

        $(window).on('scroll', () => {
            if ($(window).scrollTop() > this.scrollTreshold) {
                $('body').addClass('is-scrolled');
            } else {
                $('body').removeClass('is-scrolled');
            }
        });
    },
};

export default bob;
